export function AboutPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-slate-900 dark:text-slate-100 mb-6">
          About Privacy Forum
        </h1>

        <div className="prose prose-slate dark:prose-invert max-w-none">
          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
              Our Mission
            </h2>
            <p className="text-slate-700 dark:text-slate-300 mb-4">
              Privacy Forum is part of the <strong>maxint.dev</strong> family of products. We are a privacy-centric platform
              that enables meaningful discussions while protecting your identity. We believe in the fundamental right to
              privacy and free expression, creating a space where users can engage authentically without compromising
              their personal information.
            </p>
          </div>

          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
              Key Features
            </h2>
            <ul className="space-y-3 text-slate-700 dark:text-slate-300">
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">✓</span>
                <span><strong>WebAuthn Security:</strong> Passwordless authentication using modern cryptographic standards</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">✓</span>
                <span><strong>Alias System:</strong> Use different identities per topic while maintaining accountability</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">✓</span>
                <span><strong>Secure Marketplace:</strong> Trade services safely with built-in verification and encrypted messaging</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">✓</span>
                <span><strong>End-to-End Encryption:</strong> Your private messages remain private</span>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
}
